module.exports = __webpack_public_path__ + "media/images/athletes/1609-1476284990cc2e1af9e095edc95a7b65.png";